import moment from "moment-timezone";

import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_TIMESHEETS_WORK_CALENDAR } from "src/api-setup/api-endpoints";
import { API_CONSTANTS } from "../../providerPayRequestDashboard/utils/constants";
import { getEndOfMonthInServerTz, getStartOfMonthInServerTz } from "../utils/dateRangeHelper";

/*
 * Per-day totals already booked against a contract, used to show existing
 * hours on the Add Pay Request calendar.
 *
 * Deliberately separate from providerPayRequestDashboard/services/getWorkCalendar.js:
 * that one dispatches setWorkCalendarData, which would overwrite the dashboard's
 * own calendar state while the modal is open. This one just returns the rows.
 */
export const getWorkCalendarForContract = async (cookiesData, dispatch, { providerId, contractMstrKey, monthDate }) => {
  if (!cookiesData || !providerId) return [];

  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_provider_id: providerId,
      in_contract_type_mstr_key: null,
      in_contract_mstr_key: contractMstrKey || null,
      in_group_by: "days",
      in_filter: null,
      in_sort_number: API_CONSTANTS.DEFAULT_SORT_NUMBER,
      in_sort_order: API_CONSTANTS.DEFAULT_SORT_ORDER_ASC,
      in_start_date: getStartOfMonthInServerTz(monthDate),
      in_end_date: getEndOfMonthInServerTz(monthDate),
      in_device_local_tz: moment.tz.guess(),
    };

    const response = await POSTAPI(false, GET_TIMESHEETS_WORK_CALENDAR, null, apiHeaders, requestBody, dispatch);
    const rowResult = response?.data?.row_result;
    return Array.isArray(rowResult) ? rowResult : [];
  } catch (error) {
    console.error("Error fetching work calendar for contract:", error);
    return [];
  }
};

/* Shapes the rows into the Map that MonthCalendar renders from. */
export const buildPayRequestDataMap = (rows) => {
  const dataMap = new Map();

  (rows ?? []).forEach((item) => {
    if (!item.date || !(item.count > 0)) return;

    const dateKey = item.date.split("T")[0].split(" ")[0];

    dataMap.set(dateKey, {
      hours: item.total_hours ?? 0,
      minutes: item.total_minutes ?? 0,
      budget: item.total_budget ?? 0,
      timesheetCount: item.count ?? 0,
      shifts: item.total_shifts ?? 0,
      quantity: item.total_quantity ?? item.total_shifts ?? 0,
      contractTypes: Array.isArray(item.contract_type_counts)
        ? item.contract_type_counts.map((ct) => ({
            count: ct.count,
            contract_type_name: ct.contract_type_name ?? "",
            contract_type_mstr_key: ct.contract_type_mstr_key ?? 0,
            budget: ct.budget ?? 0,
            color_code: ct.color_code ?? "",
            hours: ct.hours ?? 0,
            minutes: ct.minutes ?? 0,
            shifts: ct.shifts ?? 0,
            quantity: ct.quantity ?? ct.shifts ?? 0,
          }))
        : [],
    });
  });

  return dataMap;
};
